export default "__VITE_ASSET__BOMfBGBb__"